var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup39074(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5404 2.18712C15.305 1.95134 14.9231 1.95094 14.6877 2.18612L7.45357 9.40119L4.84351 6.5664C4.61798 6.32159 4.23666 6.30572 3.99145 6.53122C3.74641 6.75675 3.73073 7.13825 3.95626 7.38328L6.99145 10.6796C7.1026 10.8004 7.25816 10.8705 7.4222 10.8739C7.4266 10.8741 7.43085 10.8741 7.43507 10.8741C7.59448 10.8741 7.74782 10.8108 7.86079 10.6982L15.5392 3.03997C15.7752 2.80481 15.7756 2.4229 15.5404 2.18712Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.397 7.39697C15.0639 7.39697 14.794 7.66691 14.794 8C14.794 11.7463 11.7463 14.794 8 14.794C4.25387 14.794 1.20603 11.7463 1.20603 8C1.20603 4.25387 4.25387 1.20603 8 1.20603C8.33306 1.20603 8.60303 0.936094 8.60303 0.603031C8.60303 0.269938 8.33306 0 8 0C3.58875 0 0 3.58875 0 8C0 12.4111 3.58875 16 8 16C12.4111 16 16 12.4111 16 8C16 7.66694 15.7301 7.39697 15.397 7.39697Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39074);
export default __webpack_public_path__ + "static/media/Group 39074.6668f96f59f7d3e39a74fabaaf347b80.svg";
export { ForwardRef as ReactComponent };